const agent_bill_export = {
    path: 'agent_bill_export',
    component: resolve => require(['@/pages/admin/storage_audit/agent_bill_export.vue'], resolve),
}

export default agent_bill_export